import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["input", "star"];
  static values = {
    initial: Number,
  };

  connect() {
    this.updateStars(this.initialValue || 0);
  }

  select(event) {
    const selectedValue = parseInt(event.target.value);
    this.updateStars(selectedValue);
    this.initialValue = selectedValue;
  }

  hover(event) {
    if (!event.currentTarget) return;
    const value = parseInt(event.currentTarget.querySelector("input").value);
    this.updateStars(value, true);
  }

  reset() {
    this.updateStars(this.initialValue || 0);
  }

  updateStars(selectedValue, isHover = false) {
    if (!this.hasStarTarget) return;

    this.starTargets.forEach((star) => {
      const value = parseInt(
        star.closest(".group\\:star").querySelector("input").value
      );
      const active = value <= selectedValue;

      star.dataset.variant = active ? "solid" : "outline";
      star.classList.toggle("text-yellow-400", active);
      star.classList.toggle("text-yellow-500", active && isHover);
    });
  }
}
